import React, { Component } from "react";
import { Icon, Modal, Input, Header, Button, Form, Table, Divider, Popup } from "semantic-ui-react";
import moment from "moment";
import Roundy from "../../../services/roundy";
import { grabserviceredux } from "../../../services/crudservice";
import './invoices.css';
import { invformatnumber } from "../../../services/tnminvnumbers";

class PaymentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentAmount: 0,
      status: "create",
      payment: {
        amount: 0,
        payment_date: moment().format('YYYY-MM-DD'),
        check_number: ""
      },
    };
  }
  componentDidMount() {
    if (this.props.payInvoice) {
      this.setState({
        defaultpayment: Object.assign({}, this.state.payment),
        payInvoice: Object.assign({}, this.props.payInvoice)
      });
    }
  }
  resetPayment() {
    this.setState({ status: "create", payment: Object.assign({}, this.state.defaultpayment) })
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.showModal && this.props.showModal === true) {
      console.log(this.props.payInvoice);
      this.setState({
        payInvoice: Object.assign({}, this.props.payInvoice),
        paymentAmount: 0
      });
    }
  }
  genPaymentTable() {
    console.log("payInvoice", this.state.payInvoice);
    if (this.state.payInvoice.payments && this.state.payInvoice.payments.length) {
      return this.state.payInvoice.payments.map(p =>
      (<Table.Row onClick={() => this.setState({ payment: p, status: "update" })}>
        <Table.Cell>{p.id}</Table.Cell>
        <Table.Cell>${p.amount}</Table.Cell>
        <Table.Cell>{p.check_number}</Table.Cell>
        <Table.Cell>{p.payment_date}</Table.Cell>
      </Table.Row>
      ))
    }


  }

  genActionButton(payInvoice) {
    // onClick={() => {
    //   this.props.editPayment(this.state.payment);
    //   this.setState({ payment: this.state.defaultpayment, status: "create" });
    // }}

    if (this.state.status === "update") {
      return (
        <Button.Group>
          <Button
            color="black"
            onClick={() => {
              this.props.editPayment(this.state.payment);
              this.resetPayment();
              this.props.handleClose()

            }}
          >
            <Icon name="pencil" />
            Update Payment
          </Button>
          <Button.Or />
          <Popup
            content='I will not flip!'
            on='click'
            pinned
            trigger={<Button
              color="red"

            >
              <Icon name="cancel" />
              Delete Payment
            </Button>}
          >
            <Button color="red" onClick={() => {

              this.props.deletePayment(this.state.payment);
              this.resetPayment();
              this.props.handleClose()

            }}>
              <Icon name="cancel" />
              Confirm Delete
            </Button>
          </Popup>

        </Button.Group>

      )
    } else if (this.state.status === "create") {
      return (
        <Button
          color="green"
          onClick={() => {
            this.props.newPayment({ ...this.state.payment, invoice_id: this.state.payInvoice.id });
            this.resetPayment();
            this.props.handleClose()

          }}
        >
          <Icon name="plus" />
          New Payment
        </Button>
      );
    }
  }

  render() {
    let payInvoice = this.state.payInvoice;
    let remaining = 0;
    if (payInvoice) {
      remaining =
        payInvoice.amount -
        (parseFloat(this.state.paymentAmount) +
          parseFloat(payInvoice.paidamount));
      return (
        <Modal
          open={this.props.showModal}
          onClose={() => {
            this.resetPayment();
            this.props.handleClose()
          }}
        >
          <Header
            icon="payment"
            content={`Invoice ${invformatnumber(payInvoice)} Payments`}
          />
          <Modal.Content>
            <Table fluid selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>ID</Table.HeaderCell>
                  <Table.HeaderCell>Amount</Table.HeaderCell>
                  <Table.HeaderCell>Check #</Table.HeaderCell>
                  <Table.HeaderCell>Date</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.genPaymentTable()}
              </Table.Body>
            </Table>
            <Divider />


            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>New Payment</label>
                  <Input
                    icon="dollar"
                    iconPosition="left"
                    onKeyPress={e => {
                      if (
                        (e.key !== "." && !parseFloat(e.key) && e.key != "0") ||
                        (e.key === "." &&
                          this.state.payment.amount.indexOf(".") !== -1)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={this.state.payment.amount}
                    onChange={e =>
                      this.setState({
                        payment: {
                          ...this.state.payment,
                          amount: e.target.value
                        }
                      })
                    }
                  />
                </Form.Field>
                <Form.Field>
                  <label>Check #</label>
                  <Input
                    value={
                      this.state.payment.check_number
                    }
                    onChange={e => {
                      this.setState({
                        payment: {
                          ...this.state.payment,
                          check_number: e.target.value
                        }
                      });
                    }}
                  />
                </Form.Field>
                <Form.Field>
                  <label>Payment Date</label>
                  <Input
                    type="date"
                    value={
                      this.state.payment.payment_date
                    }
                    onChange={e => {
                      this.setState({
                        payment: {
                          ...this.state.payment,
                          payment_date: moment(e.target.value).format("YYYY-MM-DD")
                        }
                      });
                    }}
                  />
                </Form.Field>


              </Form.Group>


              <Form.TextArea
                fluid
                label="Invoice Comments"
                value={
                  this.state.payInvoice
                    ? this.state.payInvoice.invcomments
                    : null
                }
                onChange={e => {
                  this.setState({
                    payInvoice: {
                      ...this.state.payInvoice,
                      invcomments: e.target.value
                    }
                  });
                }}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <div id="paymentModaldetail">
              <h4>
                Total: {"$" + Roundy(this.state.payInvoice.amount)}  |  Outstanding: {"$" + (isNaN(remaining) ? "-" : Roundy(remaining))}
              </h4>
            </div>

            <Button
              color="blue"
              onClick={() => {
                this.props.updateComments(this.state.payInvoice.invcomments);
              }}
            >
              Update Comments
            </Button>

            {this.genActionButton(payInvoice)}

          </Modal.Actions>
        </Modal>
      );
    } else {
      return <div />;
    }
  }
}

export default PaymentModal;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/paymentmodal.js